var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TitleWithRow", {
        attrs: { title: "Espécies florestais utilizadas e produtividade" }
      }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("InputSelect", {
            attrs: {
              label: "Espécies florestais",
              nomeAba: _vm.nomeAba,
              obrigatorio: true,
              rulesInput: !_vm.pratica.florestas.length ? "required" : "",
              opcoes: _vm.especiesFlorestais,
              widthColumn: 8
            },
            model: {
              value: _vm.especie.especie,
              callback: function($$v) {
                _vm.$set(_vm.especie, "especie", $$v)
              },
              expression: "especie.especie"
            }
          }),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules: !_vm.pratica.florestas.length ? "required" : "",
              name: _vm.nomeAba + "/Qual espécie "
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _vm.containsOption(
                      _vm.especie.especie,
                      "OUTROS",
                      "outrasEspecies"
                    )
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c("Label", {
                              attrs: {
                                label: "Qual espécie?",
                                obrigatorio: true
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              class: { "input erro": errors.length },
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.especie.outrasEspecies,
                                callback: function($$v) {
                                  _vm.$set(_vm.especie, "outrasEspecies", $$v)
                                },
                                expression: "especie.outrasEspecies"
                              }
                            }),
                            _vm._v(" "),
                            errors[0]
                              ? _c("span", { staticClass: "help erro" }, [
                                  _vm._v(" " + _vm._s(errors[0]))
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules: !_vm.pratica.florestas.length ? "required" : "",
              name: _vm.nomeAba + "/Produtividade "
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("Label", {
                          attrs: { label: "Produtividade", obrigatorio: true }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          class: { "input erro": errors.length },
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "Ex: 20 x 20", clearable: "" },
                          model: {
                            value: _vm.especie.produtividade,
                            callback: function($$v) {
                              _vm.$set(_vm.especie, "produtividade", $$v)
                            },
                            expression: "especie.produtividade"
                          }
                        }),
                        _vm._v(" "),
                        errors[0]
                          ? _c("span", { staticClass: "help erro" }, [
                              _vm._v(" " + _vm._s(errors[0]))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            width: "100%",
            top: "20px",
            display: "flex",
            "justify-content": "flex-end"
          }
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.disableButton,
                round: "",
                type: "primary"
              },
              on: {
                click: function($event) {
                  return _vm.btnAdicionar()
                }
              }
            },
            [_vm._v("\n      Adicionar\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
        _vm._l(_vm.pratica.florestas, function(l, i) {
          return _c(
            "div",
            { key: i + l.especie },
            [
              _c("Card", {
                attrs: {
                  objeto: Object.assign({}, l, {
                    especie: _vm.pratica.florestas
                      ? _vm.especiesFlorestais.find(function(floresta) {
                          return floresta.id === l.especie
                        }).nome
                      : "-"
                  }),
                  deletar: function() {
                    return _vm.btnApagar(i)
                  },
                  editar: function() {
                    return _vm.btnEditar(l, i)
                  },
                  titulo: "Espécies florestais"
                }
              })
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f45cd5b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f45cd5b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/ILPF/IlpfFloresta.vue
// module id = null
// module chunks = 